import { Box, Text } from "@chakra-ui/react";
import * as React from "react";
import * as constants from '@/utils/constants';
import { RenderItems } from "@/explore/ffl-detail/licenseByZipQuery/filters/Filters";
import { keyType } from "@/queue/types";
import { useDispatch } from "react-redux";
import { setStoresFilterModel } from "../ducks/slice";
import { getStoresFilterModel } from "../components/selector";

const StoreFilter = () => {
    const dispatch = useDispatch();
    const adminStoreFilterModel = getStoresFilterModel();

    const filterHandler = (isCurrentlyChecked: Boolean, value: string, filter?: string | null) => {
        if (Object.keys(constants.adminStoreTypeFilters).includes(value)) {
            const storeTypeList = !isCurrentlyChecked
                ? adminStoreFilterModel.is_external.values.includes(value)
                    ? adminStoreFilterModel.is_external.values
                    : [...adminStoreFilterModel.is_external.values, value]
                : adminStoreFilterModel.is_external.values.filter(
                    (status: any) => status !== value
                );
            dispatch(setStoresFilterModel(
                {
                    ...adminStoreFilterModel,
                    is_external: {
                        ...adminStoreFilterModel.is_external,
                        values: storeTypeList
                    }
                }
            ))
        }
    }
    function capitalizeWords(string: string) {
        return string.replace(/\b\w/g, (char: string) => char.toUpperCase());
    }

    return (
        <Box className="store-filter-wrapper">
            <Box className="outbound-status-filter" sx={{ marginLeft: 0 }}>
                <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
                    {constants.STORE_TYPE_LABEL}
                </Text>
                <Box marginTop={'15px'}>
                    {Object.keys(constants.adminStoreTypeFilters).map(
                        (ele: string, index: number) => {
                            return (
                                <RenderItems
                                    key={index}
                                    label={ele === 'live' ? 'Show Only Live Stores' : capitalizeWords(ele)}
                                    item={
                                        constants.adminStoreTypeFilters[
                                        ele as keyType<typeof constants.adminStoreTypeFilters>
                                        ]
                                    }
                                    value={ele}
                                    index={index}
                                    handler={filterHandler}
                                    checked={
                                        adminStoreFilterModel.is_external.values.length > 0
                                            ? adminStoreFilterModel.is_external.values.includes(ele)
                                            : false
                                    }
                                />
                            );
                        }
                    )}

                </Box>
            </Box>
        </Box>
    )
}
export default StoreFilter;